import React, { useEffect } from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoGiaoNhanVien,
  updateDataSearch,
} from "../../../actions/DuNoGiaoNhanVien";
import { formatNumber } from "utils/currencyFormat";
export const TableDanhSach = () => {
  const dispatch = useDispatch();
  const listDuNoGiaoNhanVienFull = useSelector(
    (state) => state.listDuNoGiaoNhanVienFull
  );
  const dataSearch = useSelector((state) => state.dataSearchDuNoGiaoNhanVien);

  useEffect(() => {
    dispatch(getListDuNoGiaoNhanVien(dataSearch));
  }, []);

  const loadPage = () => {
    getListDuNoGiaoNhanVien(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang
  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListDuNoGiaoNhanVien(dataSearch));
    loadPage(dataSearch);
    //setpageNumber(pageNumber);
  };
  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    dispatch(updateDataSearch(data));
    dispatch(getListDuNoGiaoNhanVien(data));
    loadPage();
  };
  const TotalQuantity = listDuNoGiaoNhanVienFull.TongBanGhi;

  return (
    <>
      <div
        className="card border-light  mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div
              className={
                "loader loader-default " +
                (listDuNoGiaoNhanVienFull.getListDuNoGiaoNhanVienLoading
                  ? "is-active"
                  : "")
              }
            ></div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-14 flex-basis-16-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do">
                        [ {listDuNoGiaoNhanVienFull.TongBanGhi} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-30 flex-basis-20-6-sm">
                    <p className="text-left">Nhân viên</p>
                  </div>

                  <div className="custom-table-header flex-basis-30 flex-basis-30-4-sm">
                    <p className="text-right">
                      Số dư nợ
                      <br />{" "}
                      <span className="color-do">
                        {formatNumber(listDuNoGiaoNhanVienFull.TongDuNo)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header text-center">
                      Số hợp đồng
                      <br />{" "}
                      <span className="color-do">
                        {listDuNoGiaoNhanVienFull.TongHopDong}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listDuNoGiaoNhanVien={listDuNoGiaoNhanVienFull.List}
                    dataSearch={dataSearch}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.pageIndex}
            pageSize={dataSearch.pageSize}
            totalCount={TotalQuantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
